import { formatAgentWalletAmountIls } from "../../../services/currencyService";
import React from "react";
import { useAppContext } from "../../../contexts/AppContext";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./PaymentInterest.scss";

const PaymentInterest = ({ currentCard }) => {
  const { interestTable } = useAppContext();
  
  if (!currentCard.amount) {
    return null;
  }
  
  // Get annual interest rate from interestTable
  const numberOfPayments = currentCard.numberofpayments || 1;
  const annualInterestRate = interestTable && interestTable[numberOfPayments] 
    ? interestTable[numberOfPayments] 
    : 0;
  
  return (
    <div className="payment-interest-message">
      <div className="payment-interest-header">
        <ExclamationCircleOutlined className="payment-interest-icon" />
        <span className="payment-interest-title">שים לב, לתשלום תתווסף ריבית תשלומים בסך</span>
        <span className="payment-interest-amount">
          {formatAgentWalletAmountIls(currentCard.paymentInterest)}
        </span>
      </div>
      <div className="payment-interest-details">
        <span className="payment-interest-calculation">
          ({formatAgentWalletAmountIls(currentCard.amountWithInterest)} ={" "}
          {currentCard.numberofpayments} חודשים ×{" "}
          {formatAgentWalletAmountIls(
            Number(currentCard.amountWithInterest) /
              Math.max(1, Number(currentCard.numberofpayments) || 1)
          )}
          )
        </span>
        {annualInterestRate > 0 && (
          <span className="payment-interest-annual">
            משקף ריבית שנתית על סך {annualInterestRate.toFixed(2)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default PaymentInterest;
